import { Component, AfterViewInit } from '@angular/core';
import { delay } from 'rxjs';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'ness-loader',
  template: `<ng-container *ngIf="loaderStatus">
  <p-progressSpinner strokeWidth="8" fill="transparent" animationDuration=".5s"></p-progressSpinner>
  <div class="p-loading p-component-overlay" style="z-index: 100000;" ></div>
</ng-container>`
})
export class LoaderComponent implements AfterViewInit {
  loaderStatus: boolean = false;

  constructor(public loaderService: LoaderService) { }

  ngAfterViewInit() {
    this.loaderService.status.pipe(
      delay(0)
    ).subscribe((b: boolean) => this.loaderStatus = b);
  }
}
